<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>
<style lang="less">
@import 'css/reset.css';
@import 'css/common.css';
@import 'css/markdown.css';
</style>


